/**
 * Promotion hero countdown — initializes all [data-promo-countdown] roots.
 */
(function () {
  function pad(n) {
    return String(n).padStart(2, '0');
  }

  function parseEndMs(root) {
    var iso = root.getAttribute('data-end-datetime');
    if (!iso) {
      var d = root.getAttribute('data-end-date');
      if (d) iso = d + 'T23:59:59';
    }
    if (!iso) return NaN;
    var t = Date.parse(iso);
    return Number.isNaN(t) ? NaN : t;
  }

  function initCountdown(root) {
    var endMs = parseEndMs(root);
    if (Number.isNaN(endMs)) return;

    var showSeconds = root.getAttribute('data-show-seconds') === 'true';
    var expiredBehavior = root.getAttribute('data-expired-behavior') || 'hide';
    var expiredMessage = root.getAttribute('data-expired-message') || '';

    var timerEl = root.querySelector('.js-promo-timer');
    var expiredEl = root.querySelector('.js-promo-countdown-expired');
    var daysEl = root.querySelector('.js-days');
    var hoursEl = root.querySelector('.js-hours');
    var minsEl = root.querySelector('.js-mins');
    var secsEl = root.querySelector('.js-secs');

    function applyExpired() {
      if (expiredBehavior === 'message' && expiredMessage) {
        if (timerEl) timerEl.hidden = true;
        if (expiredEl) {
          expiredEl.hidden = false;
          expiredEl.textContent = expiredMessage;
        }
      } else {
        root.style.display = 'none';
      }
    }

    function tick() {
      var now = Date.now();
      var distance = endMs - now;

      if (distance < 0) {
        applyExpired();
        return;
      }

      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);

      if (daysEl) daysEl.textContent = pad(days);
      if (hoursEl) hoursEl.textContent = pad(hours);
      if (minsEl) minsEl.textContent = pad(minutes);
      if (secsEl) secsEl.textContent = pad(seconds);
    }

    if (showSeconds && timerEl) {
      timerEl.classList.add('promo-hero__timer--with-seconds');
    }
    var secsItem = secsEl ? secsEl.closest('.promo-hero__timer-item') : null;
    if (secsItem) secsItem.style.display = showSeconds ? '' : 'none';
    var sepSecs = root.querySelector('.js-sep-secs');
    if (sepSecs) sepSecs.style.display = showSeconds ? '' : 'none';

    tick();
    setInterval(tick, 1000);
  }

  document.querySelectorAll('[data-promo-countdown]').forEach(initCountdown);
})();
